import { render } from "./IEmptyData.vue?vue&type=template&id=538b1942"
import script from "./IEmptyData.vue?vue&type=script&lang=js"
export * from "./IEmptyData.vue?vue&type=script&lang=js"

import "./IEmptyData.vue?vue&type=style&index=0&id=538b1942&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__